<template>
  <OfflineLayout v-if="!online"/>
  <AdminLayout v-else-if="isDashboard"/>
  <FormLayout v-else/>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useOnline } from '@vueuse/core'
import { AdminLayout, FormLayout, OfflineLayout } from '@component/Layouts'

const route = useRoute();
const online = useOnline();

const isDashboard = computed(() => route.name?.toString().includes("Admin."));
</script>